import React from 'react';
import { ArrowRight } from 'lucide-react';
import bgPattern from '../assets/youware-bg.png';

interface CTAProps {
  theme?: 'dark' | 'light';
}

const CTA: React.FC<CTAProps> = ({ theme = 'dark' }) => {
  const isLight = theme === 'light';

  return (
    <section className={`py-32 relative overflow-hidden ${isLight ? 'bg-neutral/5' : 'bg-primary'}`}>
      <div className={`absolute inset-0 ${isLight ? 'opacity-5' : 'opacity-10'}`}>
         <img src={bgPattern} className="w-full h-full object-cover" alt="pattern" />
      </div>
      <div className="container-custom relative z-10 text-center">
        <h2 className={`text-4xl md:text-5xl font-bold mb-8 ${isLight ? 'text-primary' : 'text-white'}`}>
          Ready to Transform Your Space?
        </h2>
        <a
          href="#contact"
          className={`px-10 py-5 uppercase tracking-[0.2em] text-sm font-bold transition-all shadow-xl inline-flex items-center gap-3 hover:shadow-orange-500/20 transform hover:-translate-y-1 ${
            isLight 
              ? 'bg-accent text-white hover:bg-orange-600' 
              : 'bg-accent text-white hover:bg-orange-600'
          }`}
        >
          Schedule Your Design Consultation
          <ArrowRight size={20} />
        </a>
      </div>
    </section>
  );
};

export default CTA;
